import { useContext, useEffect, useMemo, useState } from "react";
import ModuleCard from "../../components/ModuleCard/ModuleCard";
import { IFavoritesProps } from "./Favorites.interface";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import { ModuleContext } from "../../shared/providers/module/module.provider";
import { IModule } from "../../shared/interfaces/modules.interface";
import NotFound from "./../../shared/assets/imgs/not_found.svg";
import { LoadingContext } from "../../shared/providers/loading/loading.provider";

function Favorites(props: IFavoritesProps) {
    const [favorites, setFavorites] = useState<IModule[]>([]);
    const { setIsLoading } = useContext(LoadingContext);
    const { translate } = useContext(TranslationContext);
    const { modules } = useContext(ModuleContext);
    const hasModules = useMemo(() => favorites && !!favorites.length, [favorites]);

    useEffect(() => {
        setIsLoading(true);
    }, []);

    useEffect(() => {
        if (modules) {
            setFavorites(modules.filter((mod) => mod.isFavorite));
            setIsLoading(false);
        }
    }, [modules]);

    return (
        <div className="container-fluid gx-2 pt-2 pb-5 h-100">
            {hasModules && (
                <div className="row g-1">
                    <div className="col-12">
                        <h1 id="title" className="text-h3-smbd pb-1">
                            {translate("common.favorites", "Favorites")}
                        </h1>
                    </div>
                    <section className="col-12" aria-labelledby="title">
                        <div className="row g-1">
                            {favorites?.map((module) => (
                                <div className="col-12 col-md-6 col-lg-3" key={module.id}>
                                    <ModuleCard
                                        {...module}
                                        title={module.title}
                                        contentAmount={module.contentAmount}
                                        description={module.description}
                                    />
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
            )}
            {!hasModules && (
                <div className="row g-1 h-100">
                    <div className="col-12 h-100 d-flex flex-column justify-content-center align-items-center gap-03">
                        <img src={NotFound} />
                        <h1 className="text-h2-smbd">
                            {translate("favorites.no_favorites_title", "No favourites yet!")}
                        </h1>
                        <p className="m-0 color-neutrals-dark text-bd2-rg text-center">
                            {translate(
                                "favorites.no_favorites_description",
                                "Tap on the heart to add to your favourites! See them here at a glance."
                            )}
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Favorites;
